import React from "react";
import Button from "components/ui/Button";
import Icon from "components/AppIcon";

/**
 * DPAT annex navigation — `section="mode"` (report view toggle) or `section="steps"` (prev/next at annex bottom).
 */
function DpatAnnexNavigator({
  section = "both",
  activeIndex,
  total,
  labels,
  onPrevious,
  onNext,
  sheetAnnexMode,
  onSetFullMode,
  onSetAnnexMode,
}) {
  const label = labels[activeIndex] || `Annex ${activeIndex + 1}`;

  const modeToolbar = (
    <div className="flex flex-col gap-3 md:flex-row md:justify-between">
      <div>
        <p className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Report view</p>
        <p className="mt-1 text-sm text-muted-foreground">
          Step through annexes one at a time, or open the full report for print and PDF.
        </p>
      </div>
      <div className="inline-flex rounded-lg border border-border bg-muted/40 p-1">
        <button
          type="button"
          onClick={onSetFullMode}
          className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
            sheetAnnexMode === "full"
              ? "bg-[#16325a] text-white shadow-sm"
              : "text-muted-foreground hover:bg-background hover:text-foreground"
          }`}
        >
          Full report
        </button>
        <button
          type="button"
          onClick={onSetAnnexMode}
          className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
            sheetAnnexMode === "annex"
              ? "bg-[#16325a] text-white shadow-sm"
              : "text-muted-foreground hover:bg-background hover:text-foreground"
          }`}
        >
          Annex by annex
        </button>
      </div>
    </div>
  );

  const stepNavigation =
    sheetAnnexMode === "annex" && total > 0 ? (
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <Button type="button" variant="outline" onClick={onPrevious} disabled={activeIndex <= 0}>
          <Icon name="ChevronLeft" className="h-4 w-4" />
          Previous
        </Button>
        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.14em] text-muted-foreground">Assessment navigation</p>
          <p className="mt-1 text-sm font-semibold text-foreground">{label}</p>
          <p className="mt-0.5 text-xs text-muted-foreground">
            Annex {activeIndex + 1} of {total}
          </p>
        </div>
        <Button type="button" onClick={onNext} disabled={activeIndex >= total - 1}>
          Next
          <Icon name="ChevronRight" className="h-4 w-4" />
        </Button>
      </div>
    ) : null;

  if (section === "mode") {
    return <section className="card space-y-4 p-4 md:p-5">{modeToolbar}</section>;
  }

  if (section === "steps") {
    if (!stepNavigation) return null;
    return <section className="card mt-6 p-4 md:p-5">{stepNavigation}</section>;
  }

  return (
    <section className="card space-y-4 p-4 md:p-5">
      {modeToolbar}
      {stepNavigation ? <div className="border-t border-border pt-4">{stepNavigation}</div> : null}
    </section>
  );
}

export default DpatAnnexNavigator;
